function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.658 2.135a.5.5 0 01.684 0l4.516 4.308a.447.447 0 010 .653.5.5 0 01-.684 0l-3.69-3.52v9.963A.473.473 0 018 14a.473.473 0 01-.484-.461V3.576l-3.69 3.52a.5.5 0 01-.684 0 .447.447 0 010-.653l4.516-4.308z",
  fill: "#2D2D2D"
});
function SvgFlechaarriba(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}
export default __webpack_public_path__ + "/img/Flecha arriba.svg";
export { SvgFlechaarriba as ReactComponent };